export default __webpack_public_path__ + "2869216a627e42ba0482db42157377ad.png";